import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, getCurrentInstance } from 'vue';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'SyncBtn',
  props: {
		data: {
			type: Object,
			default: function () {
				return {}
			}
		},
		text: {
			type: String,
			default: "同步"
		},
		height: {
			type: String,
			default: "36"
		},
		mode: {
			type: Number,
			default: 1
		}
	},
  emits: ["change"],
  setup(__props, { emit: __emit }) {

	const props = __props;

	const { proxy } = getCurrentInstance() as any;
	const emits = __emit;
	const loading = ref(false);
	const FileId = ref("");
	let timer : any = "";

	const SyncBtn = () => {
		if (props.mode == 1) {
			emits("change");
		} else {
			if (loading.value) {
				return false;
			}
			loading.value = true;
			proxy.$api.tokenRequest({
				url: props.data.api,
				method: "POST",
				isLoading: '加载中...',
				success: (data : any) => {
					FileId.value = data.data;
					QuerypProgress();
				},
				fail: () => {
					loading.value = false;
				},
			});
		}
	};
	const QuerypProgress = () => {
		timer && clearTimeout(timer);
		proxy.$api.tokenRequest({
			url: '/queue/progress',
			data: {
				id: FileId.value
			},
			success: (res : any) => {
				if (res.data.status == 1) {
					timer = setTimeout(() => {
						clearTimeout(timer);
						QuerypProgress();
					}, 500);
				} else if (res.data.status == 2) {
					timer = setTimeout(() => {
						clearTimeout(timer);
						QuerypProgress();
					}, 500);
				} else if (res.data.status == 3) {
					loading.value = false;
					timer && clearTimeout(timer);
					proxy.$message.success("已同步完成");
					emits("change");
					close();
				} else if (res.data.status == 4) {
					loading.value = false;
					proxy.$message.error("同步失败，请重新尝试");
				}
			},
		});
	};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      class: "export-btn",
      style: _normalizeStyle({'height': props.height + 'px'}),
      type: "primary",
      onClick: SyncBtn
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          class: "fz-14",
          style: _normalizeStyle({'line-height': props.height + 'px'})
        }, "同步", 4)
      ]),
      _: 1
    }, 8, ["style"])
  ]))
}
}

})